import cn from 'classnames';
import { useState, useContext } from 'react';

import Button from 'components/common/Button';
import { PickYourMealsContext } from 'components/signUpFunnel/Contexts';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import { TEMPO } from 'lib/constants';
import styles from 'styles/components/signUpFunnel/thankYou/ShareInvitations';

const CopyInvitationLink = ({ brand, invitationLink }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [copyError, setCopyError] = useState(false);
  const { isPickYourMeals } = useContext(PickYourMealsContext);

  const copyInvitationLinkToClipboard = async link => {
    if ('clipboard' in window.navigator) {
      return await window.navigator.clipboard.writeText(link);
    } else {
      return document.execCommand('copy', true, link);
    }
  };

  const handleCopyClick = useAnalyticsCallback(
    () => {
      copyInvitationLinkToClipboard(invitationLink)
        .then(() => {
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 1500);
        })
        .catch(() => {
          setCopyError(true);
          setTimeout(() => {
            setCopyError(false);
          }, 3000);
        });
    },
    ({ logEvent, events }) => {
      if (brand) {
        if (isPickYourMeals) {
          logEvent(events.pickMeals[TEMPO].thankYou.referralClicked, {
            mealPlanSlug: TEMPO,
          });
        } else {
          logEvent(events.signUp[brand].thankYou.referralClicked);
        }
      }
    },
    [invitationLink, brand, isPickYourMeals]
  );

  return (
    <>
      <div className={styles.shareInputContainer}>
        <input
          type="text"
          value={invitationLink}
          className={cn(styles.shareInput, 'textMd')}
          readOnly
        />
        <Button
          type="button"
          onClick={handleCopyClick}
          className="btnPrimary rounded-l-none rounded-r py-2"
        >
          {isCopied ? 'Copied!' : 'Copy'}
        </Button>
      </div>
      {copyError && <div className={styles.errorMessage}>Sorry, link did not copy.</div>}
    </>
  );
};

CopyInvitationLink.propTypes = {
  invitationLink: PropTypes.string.isRequired,
  brand: PropTypes.string,
};

export default CopyInvitationLink;
